<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="国家"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="api.list"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="国家名称">
            <el-input v-model="params.CountryName" placeholder="请输入国家名称" clearable />
          </el-form-item>
                    
        </template>
        <template slot="table">
          <el-table-column prop="CountryCode" label="国家编码" align="center" width="200" />
          <el-table-column prop="CountryName" label="国家名称" />
         
          <el-table-column label="国旗" align="center" width="125px">
          <template slot-scope="{row}">
            <el-image v-if="row.CountryFlag" :src="'/api' + row.CountryFlag" style="width:100px;margin-top:8px;"></el-image>
          </template>
        </el-table-column>     
        
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
        api: require("@/api/sy/country").default,
        params: {
          CountryName: "",
       
        },
      };
    },
    methods: {
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
  </script>